import { supabase } from '@/lib/supabase'

export async function fetchHealthSnapshotsLatest(): Promise<Array<{ symbol: string; timeframe: string; count: number; latest: string | null; has500: boolean; stale_seconds: number | null; gap_count: number | null; status: string; generated_at: string }>> {
  const { data, error } = await supabase
    .from('health_snapshots')
    .select('symbol,timeframe,count,latest,has500,stale_seconds,gap_count,status,generated_at')
    .order('generated_at', { ascending: false })
  if (error) throw error
  return (data as any[]) || []
}

export async function triggerRefreshHealthSnapshot(): Promise<void> {
  const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL as string
  const anon = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY as string
  if (!supabaseUrl || !anon) throw new Error('Supabase URL/Anon key não configurados')
  const session = await supabase.auth.getSession()
  const token = session.data.session?.access_token || anon
  const res = await fetch(`${supabaseUrl.replace(/\/$/, '')}/functions/v1/refresh-health`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}`, apikey: anon },
  })
  if (!res.ok) throw new Error(await res.text())
}

